import history from 'components/MainRouter/history';

export const goToAccount = () => {
  history.push('/account');
};

export const goToVerificationPage = () => {
  history.push('/account/verification');
};

export const goToAccountNumbersPage = () => {
  history.push('/account/profile/account-numbers');
};

export const goToRealityCheck = () => {
  history.push('/account/responsible-gaming/reality-check');
};

export const goToSelfRegulation = () => {
  history.push('/account/responsible-gaming/self-regulation');
};
